var React = require('react');

function StarsFull (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.86875 15L4.6125 9.3L0 6H5.7L7.5 0L9.3 6H15L10.3875 9.3L12.1312 15L7.5 11.475L2.86875 15Z","fill":"#D6A444","key":0}),React.createElement("path",{"d":"M17.8687 15L19.6125 9.3L15 6H20.7L22.5 0L24.3 6H30L25.3875 9.3L27.1312 15L22.5 11.475L17.8687 15Z","fill":"#D6A444","key":1}),React.createElement("path",{"d":"M32.8687 15L34.6125 9.3L30 6H35.7L37.5 0L39.3 6H45L40.3875 9.3L42.1312 15L37.5 11.475L32.8687 15Z","fill":"#D6A444","key":2}),React.createElement("path",{"d":"M47.8687 15L49.6125 9.3L45 6H50.7L52.5 0L54.3 6H60L55.3875 9.3L57.1312 15L52.5 11.475L47.8687 15Z","fill":"#D6A444","key":3}),React.createElement("path",{"d":"M62.8687 15L64.6125 9.3L60 6H65.7L67.5 0L69.3 6H75L70.3875 9.3L72.1312 15L67.5 11.475L62.8687 15Z","fill":"#D6A444","key":4})]);
}

StarsFull.defaultProps = {"viewBox":"0 0 75 15","fill":"none"};

module.exports = StarsFull;

StarsFull.default = StarsFull;
